import type { DsrDirectoryListResult } from '@getaccept/lib-shared/src/library/types/dsr-list-result';
import { GraphQLFetchPolicy } from '@getaccept/lib-shared/src/graphql/graphql-fetch-policy';
import { apolloClientInternal } from '@getaccept/lib-shared/src/internal/apollo-client-internal';
import { loadDealroomDirectories } from '@getaccept/dsr-shared';
import type { LoadDirectoriesDTO } from '@getaccept/dsr-shared';

export class LibraryService {
  static async loadDirectories(payload: LoadDirectoriesDTO): Promise<DsrDirectoryListResult> {
    const {
      data: {
        dsrDirectoriesV2: { directories, totalCount },
      },
    } = await apolloClientInternal.query({
      query: loadDealroomDirectories,
      variables: { ...payload },
      fetchPolicy: GraphQLFetchPolicy.CacheFirst,
    });
    return { directories, totalCount };
  }
}
